// removed by extract-text-webpack-plugin
module.exports = {"container":"NotificationContainer__container___3JZPD"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/NotificationContainer.css
// module id = 1565
// module chunks = 0